import React, { Fragment, useState, useEffect } from 'react'
import callApi from '../../helpers/callapi'
import { Card, Button, Row, Col, Table, Modal, Tab, Nav } from 'react-bootstrap'
import { useDispatch } from 'react-redux'
import Pagination from '../../components/Nav/Pagination'
import Cookies from 'js-cookie'
import config from '../../config'
import axios from 'axios'

export default function WithdrawalRequest() {
  const [status, setStatus] = useState('all')
  const [affiliateData, setAffiliateData] = useState([])
  const [id, setId] = useState('')
  const [showConfirmed, setShowConfirmed] = useState(false)
  const [currentPage, setCurrentPage] = useState(1)
  const dispatch = useDispatch()

  const fetchAffiliate = async (page) => {
    try {
      dispatch({ type: 'loading_show' })
      const query = {
        status: status === 'all' ? '' : status,
        page: page || 1,
        limit: 20,
      }
      const result = await axios.get(`${config.affiliateApiURL}/affiliates/withdraws`, {
        headers: {
          authorization: `Bearer ${Cookies.get('accessToken')}`,
        },
        params: query,
      })
      setAffiliateData(result.data.data)
      dispatch({ type: 'loading_hide' })
    } catch (error) {
      setAffiliateData([])
      dispatch({ type: 'loading_hide' })
    }
  }
  useEffect(() => {
    fetchAffiliate()
    setCurrentPage(1)
  }, [status])

  const onChangePage = (page) => {
    setCurrentPage(page)
    fetchAffiliate(page)
  }

  const updateAffiliate = async (id) => {
    try {
      await axios.post(
        `${config.affiliateApiURL}/affiliates/withdraws/` + id + '/approve',
        {},
        {
          headers: {
            authorization: `Bearer ${Cookies.get('accessToken')}`,
          },
        },
      )
    } catch (error) {
      alert('error')
    }
  }

  const displayTableWithDraw = () => {
    return (
      <Table responsive striped bordered className="verticle-middle">
        <thead>
          <tr>
            <th>วันที่/เวลา</th>
            <th>รหัสสมาชิก</th>
            <th>ชื่อลูกค้า</th>
            <th>สถานะ</th>
            <th>ยอดรวม</th>
            <th> </th>
          </tr>
        </thead>
        <tbody>
          {affiliateData &&
            affiliateData.map((value, i) => {
              return (
                <tr key={i}>
                  <td>{new Date(value.createdAt).toLocaleString('TH-th')}</td>
                  <td>{value.userNo}</td>
                  <td>{value.name}</td>
                  <td>{value.status === 'approve' ? 'โอนเงินแล้ว' : 'รอโอนเงิน'}</td>
                  <td>{value.amount ? value.amount.toLocaleString() : value.amount}</td>
                  <td>
                    {value.status === 'pending' ? (
                      <Button
                        variant="primary light"
                        onClick={() => {
                          setShowConfirmed(true)
                          setId(value.id)
                        }}
                      >
                        Approve
                      </Button>
                    ) : (
                      <>ยืนยันโดย </>
                    )}{' '}
                    {value.approvedBy}{' '}
                  </td>
                </tr>
              )
            })}
        </tbody>
      </Table>
    )
  }

  const displayTabStatus = () => {
    return (
      <Row className="d-flex justify-content-start align-items-center mb-4">
        <b style={{ marginLeft: '20px' }}>สถานะ : </b>
        <Col>
          <Tab.Container defaultActiveKey="all">
            <Nav as="ul" className="nav-pills light">
              <Nav.Item
                as="li"
                onClick={() => {
                  setStatus('all')
                }}
              >
                <Nav.Link eventKey="all">ทั้งหมด</Nav.Link>
              </Nav.Item>
              <Nav.Item
                as="li"
                onClick={() => {
                  setStatus('pending')
                }}
              >
                <Nav.Link eventKey="pending">รอโอนเงิน</Nav.Link>
              </Nav.Item>
              <Nav.Item
                as="li"
                onClick={() => {
                  setStatus('approve')
                }}
              >
                <Nav.Link eventKey="approve">โอนเงินแล้ว</Nav.Link>
              </Nav.Item>
            </Nav>
          </Tab.Container>
        </Col>
      </Row>
    )
  }

  return (
    <Fragment>
      <Card>
        <Card.Header>
          <Card.Title>แจ้งถอนเงิน</Card.Title>
        </Card.Header>
        <Card.Body>
          {displayTabStatus()}
          {displayTableWithDraw()}
          <Pagination
            currentPage={currentPage}
            onPrevPage={() => onChangePage(currentPage - 1)}
            onNextPage={() => onChangePage(currentPage + 1)}
            items={affiliateData || []}
            perPage={20}
          />
        </Card.Body>
      </Card>
      <Modal show={showConfirmed}>
        <Modal.Header>ยืนยัน</Modal.Header>
        <Modal.Body>ยืนยันการจ่ายเงิน ?</Modal.Body>
        <Modal.Footer>
          <Button variant="danger light" onClick={() => setShowConfirmed(false)}>
            ยกเลิก
          </Button>
          <Button
            variant="primary light"
            onClick={() => {
              updateAffiliate(id)
              setShowConfirmed(false)
            }}
          >
            ยืนยัน
          </Button>
        </Modal.Footer>
      </Modal>
    </Fragment>
  )
}
